// extracted by mini-css-extract-plugin
export default {"pluginsintro":"pluginsintro_c4df05c0328fa1f051e8","platforms":"platforms_c3e6a3a03a2aef5c8ce4","name":"name_a636ccda3ff46b0ad139"};